module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nucleicAcid paddingTop45"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("核酸检测申请"), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.ListDetailshow = true
      }
    },
    slot: "right"
  }, [_vm._v("申请记录")])]), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "150px",
      "title": "请填写就诊信息"
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "right",
      "title": "就诊卡/身份证/电话",
      "placeholder": "请输入就诊卡/身份证/电话"
    },
    on: {
      "on-blur": _vm.cardBlur
    },
    model: {
      value: (_vm.card),
      callback: function($$v) {
        _vm.card = $$v
      },
      expression: "card"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cardIcon),
      expression: "cardIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "姓名",
      "value": _vm.name
    }
  }, [_c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personoptions.length > 1),
      expression: "personoptions.length > 1"
    }],
    staticClass: "bulesolidBtn",
    staticStyle: {
      "margin-left": "10px",
      "padding": "0 5px"
    },
    attrs: {
      "slot": "child",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.personshow = true
      }
    },
    slot: "child"
  }, [_vm._v("切换身份")])], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "出生日期",
      "value": _vm.birthday
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "就诊院区",
      "value": _vm.hospital
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "检测项目信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "项目代码",
      "value": _vm.diagItemCode
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "项目名称",
      "value": _vm.diagItemName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "检测费用",
      "value": _vm.diagItemPrice + '元'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 10px 10px"
    }
  }, [_c('x-button', {
    staticClass: "orangeBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisable
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("提交订单")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    attrs: {
      "hide-on-blur": false
    },
    model: {
      value: (_vm.personshow),
      callback: function($$v) {
        _vm.personshow = $$v
      },
      expression: "personshow"
    }
  }, [_c('div', {
    staticClass: "nucleicAcidpersonpopup"
  }, [_c('p', [_vm._v("系统检测出您有多重账号，请选择其中一条")]), _vm._v(" "), _c('radio', {
    attrs: {
      "options": _vm.personoptions
    },
    on: {
      "on-change": _vm.personchange
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    staticClass: "nucleicAcidListDetail",
    attrs: {
      "hide-on-blur": true,
      "title": "核酸申请记录",
      "cancel-text": "关闭",
      "show-confirm-button": false
    },
    model: {
      value: (_vm.ListDetailshow),
      callback: function($$v) {
        _vm.ListDetailshow = $$v
      },
      expression: "ListDetailshow"
    }
  }, [_c('ul', {
    staticStyle: {
      "text-align": "left"
    }
  }, _vm._l((_vm.ListDetail), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.look(item.applictionNo)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.identityNo) + " " + _vm._s(item.patientName) + " " + _vm._s(item.orderedDate))])])
  }))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249e3143","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/selfHelpFilingProject/nucleicAcid.vue
// module id = s/P7
// module chunks = 7